export const xpsrNFTs = [
  
  {
    "id": "xpsr-4888",
    "name": "XPSR #4888",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/3e10b8168f6ad432a2959defc5a942e5.png",
    "price": "0.15 ETH"
  },
  {
    "id": "xpsr-4887",
    "name": "XPSR #4887", 
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/44c6a79323ae89479276b0f53bb0fb32.png",
    "price": "0.08 ETH"
  },
  {
    "id": "xpsr-4885",
    "name": "XPSR #4885",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/cfaa12a77605628bc85cc7ff0a0ff471.png",
    "price": "0.19 ETH"
  },
  {
    "id": "xpsr-4886",
    "name": "XPSR #4886",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/b9102ba1af1f210d2334d8c262d9bd24.png",
    "price": "0.12 ETH"
  },
  {
    "id": "xpsr-4884",
    "name": "XPSR #4884",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/c889a9519c8eb0936530a0cd567b8bdf.png",
    "price": "0.06 ETH"
  },
  {
    "id": "xpsr-4883",
    "name": "XPSR #4883",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/3b95335cd88c19ae82dbd4329dbad755.png",
    "price": "0.17 ETH"
  },
  {
    "id": "xpsr-4882",
    "name": "XPSR #4882",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/293c3de8c464f2a3fed03b2841531e95.png",
    "price": "0.11 ETH"
  },
  {
    "id": "xpsr-4879",
    "name": "XPSR #4879",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/b66c7d00c333fd6a92240e243314651d.png",
    "price": "0.05 ETH"
  },
  {
    "id": "xpsr-4880",
    "name": "XPSR #4880",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/481ce9cfd2c564902510e232751b42f8.png",
    "price": "0.16 ETH"
  },
  {
    "id": "xpsr-4881",
    "name": "XPSR #4881",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/f0845713fd05f4f0829fb8cb35cd0314.png",
    "price": "0.09 ETH"
  },
  {
    "id": "xpsr-4878",
    "name": "XPSR #4878",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/3cb94a62c10a271541cd7d03949071ac.png",
    "price": "0.20 ETH"
  },
  {
    "id": "xpsr-4877",
    "name": "XPSR #4877",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/47199a9cbe498b16910cba5123a99d5d.png",
    "price": "0.13 ETH"
  },
  {
    "id": "xpsr-4876",
    "name": "XPSR #4876",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/34c40209bb3bc024addf9926a1c918b4.png",
    "price": "0.07 ETH"
  },
  {
    "id": "xpsr-4875",
    "name": "XPSR #4875",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/51177831f1b1d70a1c0d303024e0a8ef.png",
    "price": "0.18 ETH"
  },
  {
    "id": "xpsr-4874",
    "name": "XPSR #4874",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/451e4c1e4980701305a5fee07a79f775.png",
    "price": "0.10 ETH"
  },

  {
    "id": "xpsr-4872",
    "name": "XPSR #4872",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/388b0189d618ad389043d24f1207515a.png",
    "price": "0.14 ETH"
  },
  {
    "id": "xpsr-4871",
    "name": "XPSR #4871",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/23c3d8bbfb24254ba5d3037393670d19.png",
    "price": "0.08 ETH"
  },
  {
    "id": "xpsr-4873",
    "name": "XPSR #4873",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/3c7a4af3f494b2a61305c5d1c392d500.png",
    "price": "0.17 ETH"
  },
  {
    "id": "xpsr-4870",
    "name": "XPSR #4870",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/cfa0bcacae3eb40ca58a5c1ed5112414.png",
    "price": "0.11 ETH"
  },
  {
    "id": "xpsr-4869",
    "name": "XPSR #4869",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/f17ad127098e18c266ef98f4880225db.png",
    "price": "0.05 ETH"
  },
  {
    "id": "xpsr-4868",
    "name": "XPSR #4868",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/e76161c70d784fbb0fafe795f158ec69.png",
    "price": "0.19 ETH"
  },
  {
    "id": "xpsr-4865",
    "name": "XPSR #4865",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/1248db64527ba1eadfddb770ca8f9013.png",
    "price": "0.13 ETH"
  },
  {
    "id": "xpsr-4867",
    "name": "XPSR #4867",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/62ca919d3f55c085606684104b2a399e.png",
    "price": "0.07 ETH"
  },
  {
    "id": "xpsr-4864",
    "name": "XPSR #4864",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/19877e43ba88ffdb2eab0fa9ae95c906.png",
    "price": "0.16 ETH"
  },
  {
    "id": "xpsr-4866",
    "name": "XPSR #4866",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/080e88afdfe3c45c02744774de92ba9a.png",
    "price": "0.09 ETH"
  },
  {
    "id": "xpsr-4863",
    "name": "XPSR #4863",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/0ef5f82faf179ef8a95452b7ab15cc51.png",
    "price": "0.20 ETH"
  },
  {
    "id": "xpsr-4860",
    "name": "XPSR #4860",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/aa9dabb85dd5811f7985af94033b74b2.png",
    "price": "0.12 ETH"
  },
  {
    "id": "xpsr-4862",
    "name": "XPSR #4862",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/4d21f86168a9815035cd34105789715d.png",
    "price": "0.06 ETH"
  },
  {
    "id": "xpsr-4861",
    "name": "XPSR #4861",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/02ec4b2e0e689ec125c08641f8d5b477.png",
    "price": "0.18 ETH"
  },
  {
    "id": "xpsr-4859",
    "name": "XPSR #4859",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/7bc903e3d29a41789fd2e3354d2ca72d.png",
    "price": "0.10 ETH"
  },
  {
    "id": "xpsr-4857",
    "name": "XPSR #4857",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/2bc6f41801fba3f7fd229ab8eafdccb8.png",
    "price": "0.15 ETH"
  },
  {
    "id": "xpsr-4858",
    "name": "XPSR #4858",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/fe31077207ffeff2fecd7900303e27f4.png",
    "price": "0.08 ETH"
  },
  {
    "id": "xpsr-4856",
    "name": "XPSR #4856",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/47a756552a71383526bb78a495c6b5bb.png",
    "price": "0.19 ETH"
  },
  {
    "id": "xpsr-4854",
    "name": "XPSR #4854",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/a3fefe6514941cb12d5555084679048f.png",
    "price": "0.11 ETH"
  },
  {
    "id": "xpsr-4855",
    "name": "XPSR #4855",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/8460c276e0966d15c5c569d35f43a221.png",
    "price": "0.04 ETH"
  },
  {
    "id": "xpsr-4853",
    "name": "XPSR #4853",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/74ef248a0bfb44a2a166f4cd3322d037.png",
    "price": "0.17 ETH"
  },
  {
    "id": "xpsr-4850",
    "name": "XPSR #4850",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/f1605133ba421e74cdb6697f3534629d.png",
    "price": "0.13 ETH"
  },
  {
    "id": "xpsr-4852",
    "name": "XPSR #4852",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/79b871d49295375fb0f98266b848707b.png",
    "price": "0.07 ETH"
  },
  {
    "id": "xpsr-4849",
    "name": "XPSR #4849",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/68febd9a0587166a3bde3628611c4d12.png",
    "price": "0.16 ETH"
  },
  {
    "id": "xpsr-4848",
    "name": "XPSR #4848",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/050858f1b31ef71fe2dff30d982ccbaa.png",
    "price": "0.09 ETH"
  },
  {
    "id": "xpsr-4847",
    "name": "XPSR #4847",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/8138f9f58d7f2aa0696a34e5e02e4d8a.png",
    "price": "0.20 ETH"
  },
  {
    "id": "xpsr-4846",
    "name": "XPSR #4846",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/269e9f1f0e677e8b9ae8d4b74ce82c20.png",
    "price": "0.12 ETH"
  },
  {
    "id": "xpsr-4845",
    "name": "XPSR #4845",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/b579fcc9719e8113dfa1e105a045004c.png",
    "price": "0.06 ETH"
  },
  {
    "id": "xpsr-4844",
    "name": "XPSR #4844",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/bd9b0964253e3bd9de7e1182a48d7e23.png",
    "price": "0.18 ETH"
  },
  {
    "id": "xpsr-4843",
    "name": "XPSR #4843",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/a904d001c11e485f8aa03d79b151e28d.png",
    "price": "0.10 ETH"
  },
  {
    "id": "xpsr-4842",
    "name": "XPSR #4842",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/99d6f1ddfd66a9cceb36d0ccac8dcada.png",
    "price": "0.14 ETH"
  },
  {
    "id": "xpsr-4841",
    "name": "XPSR #4841",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/4cc946b12416be104ff23f02e33e1d65.png",
    "price": "0.08 ETH"
  },
  {
    "id": "xpsr-4840",
    "name": "XPSR #4840",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/b0d12e796d8e8ecc954385f27e8ff5d5.png",
    "price": "0.19 ETH"
  },
  {
    "id": "xpsr-4839",
    "name": "XPSR #4839",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/43f58743b62cbbe7ae12f0b2c3dbb2d0.png",
    "price": "0.11 ETH"
  },
  {
    "id": "xpsr-4838",
    "name": "XPSR #4838",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/e04206753426e471f8748eb4138bad6b.png",
    "price": "0.05 ETH"
  },
  {
    "id": "xpsr-4837",
    "name": "XPSR #4837",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/6de5cde224ffe8be4102e4bc25872932.png",
    "price": "0.17 ETH"
  },
  {
    "id": "xpsr-4836",
    "name": "XPSR #4836",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/68b23f1b31405d62fdde3e37144a1b84.png",
    "price": "0.13 ETH"
  },
  {
    "id": "xpsr-4835",
    "name": "XPSR #4835",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/582d02b1f5b5763e86e4ff1eb0cbc74c.png",
    "price": "0.07 ETH"
  },
  {
    "id": "xpsr-4834",
    "name": "XPSR #4834",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/3eca98b9ca977fc60adad304539880d0.png",
    "price": "0.16 ETH"
  },
  {
    "id": "xpsr-4833",
    "name": "XPSR #4833",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/7f7f276f7adaa607b96b4f24c98bca30.png",
    "price": "0.09 ETH"
  },
  {
    "id": "xpsr-4832",
    "name": "XPSR #4832",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/b757f868646eb9465df8941fc687dffd.png",
    "price": "0.20 ETH"
  },
  {
    "id": "xpsr-4831",
    "name": "XPSR #4831",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/89200b81916d71a79558531196f8613b.png",
    "price": "0.12 ETH"
  },
    
  {
    "id": "xpsr-4830",
    "name": "XPSR #4830",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/03e84b83609f7aeb7355fa497bbe8250.png",
    "price": "0.15 ETH"
  },
  {
    "id": "xpsr-4829",
    "name": "XPSR #4829",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/0455f100c6acc4a65aa5827115069884.png",
    "price": "0.08 ETH"
  },
  {
    "id": "xpsr-4828",
    "name": "XPSR #4828",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/6e0bf1b8c83e6eda572616e032b3af2a.png",
    "price": "0.19 ETH"
  },
  {
    "id": "xpsr-4826",
    "name": "XPSR #4826",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/bffbe47ed41030675cc8f90429fcac34.png",
    "price": "0.11 ETH"
  },
  {
    "id": "xpsr-4827",
    "name": "XPSR #4827",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/a3b6bb4fa7f10f3ac03f93d34bf85d4b.png",
    "price": "0.05 ETH"
  },
  {
    "id": "xpsr-4825",
    "name": "XPSR #4825",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/70e18680ed60ad2cc049702a9d71b3c4.png",
    "price": "0.17 ETH"
  },
  {
    "id": "xpsr-4824",
    "name": "XPSR #4824",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/07d76eb5b6bae00edbd108240157e47c.png",
    "price": "0.13 ETH"
  },
  {
    "id": "xpsr-4823",
    "name": "XPSR #4823",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/3bddcb4892aa6864f7f3ca7135898176.png",
    "price": "0.07 ETH"
  },
  {
    "id": "xpsr-4821",
    "name": "XPSR #4821",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/a12907216fbefa41b79345d374c1d87e.png",
    "price": "0.16 ETH"
  },
  {
    "id": "xpsr-4822",
    "name": "XPSR #4822",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/14520b1cf3759ff98a1353863c6608f0.png",
    "price": "0.09 ETH"
  },
  {
    "id": "xpsr-4820",
    "name": "XPSR #4820",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/338e9a8d357df3352799036279a36d50.png",
    "price": "0.20 ETH"
  },
  {
    "id": "xpsr-4818",
    "name": "XPSR #4818",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/36208fe9af2930c0457519debdb95c3d.png",
    "price": "0.12 ETH"
  },
  {
    "id": "xpsr-4819",
    "name": "XPSR #4819",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/32768dba1d31d90b822a77ce36b2a586.png",
    "price": "0.06 ETH"
  },
  {
    "id": "xpsr-4817",
    "name": "XPSR #4817",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/fe4b89aebf700700ad0ae964a122ccf3.png",
    "price": "0.18 ETH"
  },
  {
    "id": "xpsr-4816",
    "name": "XPSR #4816",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/f48ccd305c956efffa34c0f493b1b1f3.png",
    "price": "0.10 ETH"
  },
  {
    "id": "xpsr-4815",
    "name": "XPSR #4815",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/3d8b320177824ffe5bb56a4ad652e7b7.png",
    "price": "0.14 ETH"
  },
  {
    "id": "xpsr-4814",
    "name": "XPSR #4814",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/0cf9f98eb76516b73d22fe006e87b012.png",
    "price": "0.08 ETH"
  },
  {
    "id": "xpsr-4813",
    "name": "XPSR #4813",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/cd7812170731052fa2b6084ee1b3c6e6.png",
    "price": "0.19 ETH"
  },
  {
    "id": "xpsr-4812",
    "name": "XPSR #4812",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/ca9aa78ff4ada01a1990431c2ca0110f.png",
    "price": "0.11 ETH"
  },
  {
    "id": "xpsr-4811",
    "name": "XPSR #4811",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/a75985b712594f806af4522a3ae22294.png",
    "price": "0.04 ETH"
  },
  {
    "id": "xpsr-4809",
    "name": "XPSR #4809",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/1e5330ac64d0dd67f44250e222ff3f4d.png",
    "price": "0.17 ETH"
  },
  {
    "id": "xpsr-4810",
    "name": "XPSR #4810",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/b7efb92ce99cd80db29f26468ba228a0.png",
    "price": "0.13 ETH"
  },
  {
    "id": "xpsr-4807",
    "name": "XPSR #4807",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/cd8cd882f91934936ab23c4e773c44b1.png",
    "price": "0.07 ETH"
  },
  {
    "id": "xpsr-4808",
    "name": "XPSR #4808",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/6b7ef6573a9adaeec32de4b2b48e0dcc.png",
    "price": "0.16 ETH"
  },
  {
    "id": "xpsr-4806",
    "name": "XPSR #4806",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/47a0e6d81433fbd6117a1d08433e7f7e.png",
    "price": "0.09 ETH"
  },
  {
    "id": "xpsr-4805",
    "name": "XPSR #4805",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/5b28afc09a5d4f9e2c3c0d5208b87c5f.png",
    "price": "0.20 ETH"
  },
  {
    "id": "xpsr-4804",
    "name": "XPSR #4804",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/39ece1a15c331f1b5d3b9ab07b7bfa11.png",
    "price": "0.12 ETH"
  },
  {
    "id": "xpsr-4803",
    "name": "XPSR #4803",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/8d9c8e2db2241bc13906146472e6b691.png",
    "price": "0.06 ETH"
  },
  {
    "id": "xpsr-4802",
    "name": "XPSR #4802",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/1be33142eb50778ce7d7a3f3ecdfed41.png",
    "price": "0.18 ETH"
  },
  {
    "id": "xpsr-4799",
    "name": "XPSR #4799",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/72b42dd7ad2d2e51a331d21f7b4ad276.png",
    "price": "0.10 ETH"
  },
  {
    "id": "xpsr-4801",
    "name": "XPSR #4801",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/204e69033d4120efc9dcc22f7a102570.png",
    "price": "0.15 ETH"
  },
  {
    "id": "xpsr-4798",
    "name": "XPSR #4798",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/c985977ead73eb6a68eb7b2baa2d51f0.png",
    "price": "0.08 ETH"
  },
  {
    "id": "xpsr-4800",
    "name": "XPSR #4800",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/e7e99744fed78ec6525216ce9d0a36d0.png",
    "price": "0.19 ETH"
  },
  {
    "id": "xpsr-4797",
    "name": "XPSR #4797",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/107daaa8290fb6fee1d47f98b5f67505.png",
    "price": "0.11 ETH"
  },
  {
    "id": "xpsr-4796",
    "name": "XPSR #4796",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/4092433f05f0f6644772b6d8ad10e1ff.png",
    "price": "0.05 ETH"
  },
  {
    "id": "xpsr-4794",
    "name": "XPSR #4794",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/1b43f4e11b749ab87b74c2847700d86a.png",
    "price": "0.17 ETH"
  },
  {
    "id": "xpsr-4795",
    "name": "XPSR #4795",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/b44e1a39dc6585195561098f9f4af802.png",
    "price": "0.13 ETH"
  },
  {
    "id": "xpsr-4793",
    "name": "XPSR #4793",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/f4f7a9453d1d58a3ba361cb470f8913c.png",
    "price": "0.07 ETH"
  },
  {
    "id": "xpsr-4792",
    "name": "XPSR #4792",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/e17cf21cb31df478ab53d4268de57259.png",
    "price": "0.16 ETH"
  },
  {
    "id": "xpsr-4791",
    "name": "XPSR #4791",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/0818626a03c6c83c4e63dba5d5c34632.png",
    "price": "0.09 ETH"
  },
  {
    "id": "xpsr-4789",
    "name": "XPSR #4789",
    "image": "https://staticassets.confiction.com/web/nft-assets/xpsr/62fe3f1ee5273b33f580af24b73d6091.png",
    "price": "0.20 ETH"
  }




];